// Chemin: C:\gestion-copro\src\types\conseilSyndical.types.ts

import { Timestamp } from 'firebase/firestore';

/**
 * Rôles possibles au sein du conseil syndical
 */
export type RoleCS = 'president' | 'vice_president' | 'secretaire' | 'tresorier' | 'membre';

/**
 * Membre du conseil syndical
 */
export interface MembreCS {
  id: string;
  coproprieteId: string;
  
  // Identité
  nom: string;
  prenom: string;
  
  // Contact
  email?: string;
  telephone?: string;
  
  // Lien avec la copropriété
  lotId?: string;
  lotNumero?: string;
  userId?: string;
  
  // Fonction au CS
  role: RoleCS;
  
  // Mandat
  dateElection: Timestamp;
  agElectionRef?: string;
  dateFinMandat?: Timestamp;
  
  // Statut
  actif: boolean;
  
  // Métadonnées
  notes?: string;
  createdAt: Timestamp;
  updatedAt: Timestamp;
}

/**
 * Données pour création
 */
export interface MembreCSCreateData {
  coproprieteId: string;
  nom: string;
  prenom: string;
  email?: string;
  telephone?: string;
  lotId?: string;
  lotNumero?: string;
  userId?: string;
  role: RoleCS;
  dateElection: Date;
  agElectionRef?: string;
  dateFinMandat?: Date;
  actif?: boolean;
  notes?: string;
}

/**
 * Données pour mise à jour
 */
export interface MembreCSUpdateData {
  nom?: string;
  prenom?: string;
  email?: string;
  telephone?: string;
  lotId?: string;
  lotNumero?: string;
  userId?: string;
  role?: RoleCS;
  dateElection?: Date;
  agElectionRef?: string;
  dateFinMandat?: Date;
  actif?: boolean;
  notes?: string;
}

/**
 * Labels pour l'affichage
 */
export const ROLE_CS_LABELS: Record<RoleCS, string> = {
  president: 'Président(e)',
  vice_president: 'Vice-président(e)',
  secretaire: 'Coordinateur / Coordinatrice',
  tresorier: 'Trésorier(ère)',
  membre: 'Membre'
};

/**
 * Ordre de tri des rôles (pour affichage)
 */
export const ROLE_CS_ORDRE: Record<RoleCS, number> = {
  president: 1,
  vice_president: 2,
  secretaire: 3,
  tresorier: 4,
  membre: 5
};

/**
 * Pour l'affichage condensé d'un membre
 */
export interface MembreCSResume {
  id: string;
  nomComplet: string;
  role: RoleCS;
  lotNumero?: string;
  actif: boolean;
}